import React, { useLayoutEffect, useState } from "react";
import "./TabViewRenderer.css";
import { TabHead } from "./TabHead";
import DetailsviewPreview from "../DetailsviewPreview";

const TabViewRenderer = ({ configData = {} }) => {
  const { headerData, bodyData = {} } = configData;
  const [selectedTab, setSelectedTab] = useState(null);

  useLayoutEffect(() => {
    if (!selectedTab) {
      let id = headerData?.[0]?.["id"];
      if (headerData?.[0]) {
        headerData[0].active = true;
      }
      setSelectedTab(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerData]);

  return (
    <div>
      <div className={"tabview_renderer_outerbox static_field_blocks"}>
        {headerData ? <TabHead headerData={headerData} openTab={setSelectedTab} /> : <div>Header data not found</div>}
        {selectedTab && bodyData[selectedTab] ? (
          <DetailsviewPreview detailviewConfig={bodyData[selectedTab]} />
        ) : (
          <div>Page data not found</div>
        )}
      </div>
    </div>
  );
};

export default TabViewRenderer;
